import * as React from "react";
// select の選択肢関連用

// 配列から選択肢を作るfunction Enum系用 いずれmapオブジェクトからに置き換える
export const createNoRequiredOptionItem = (list: any[]) => {
  return list.map((item, index) => {
    if (item === "不明") {
      return <option value={index} key={index} />;
    } else {
      return (
        <option value={index} key={index}>
          {item}
        </option>
      );
    }
  });
};

// 必須項目を表現するために初期表示用の選択不可かつvalueなしのoptionをいれている
export const createRequiredOptionItem = (list: any[]) => {
  return list.map((item, index) => {
    if (item === "不明") {
      return <option key={index} disabled={true} />;
    } else {
      return (
        <option value={index} key={index}>
          {item}
        </option>
      );
    }
  });
};

// mapオブジェクトから選択肢をつくるfunction Enum系用
export const createSelectItem: any = (
  canEmpty: boolean,
  list: Map<any, string>
) => {
  const res: any[] = [];

  list.forEach((value, key) => {
    if (key === 0) {
      if (canEmpty) {
        return res.push(<option value={key} key={key} />);
      }
      return;
    } else {
      return res.push(
        <option value={key} key={key}>
          {value}
        </option>
      );
    }
  });

  return res;
};

export type SelectItem = {
  key: string;
  value: string;
};

export const createSelectItem2: any = (
  list: SelectItem[],
  emptyText: string
) => {
  const res: any[] = [];
  if (emptyText) {
    res.push(
      <option value={""} key={""}>
        {emptyText}
      </option>
    );
  }

  list.forEach((val) => {
    return res.push(
      <option value={val.key} key={val.key}>
        {val.value}
      </option>
    );
  });

  return res;
};

// 日付用の選択肢を作るfunction
export const createAddressOptionDom = (list: string[]) => {
  return list.map((item, index) => {
    if (item === "不明") {
      return <option key={index} disabled={true} />;
    } else {
      return (
        <option value={item} key={index}>
          {item}
        </option>
      );
    }
  });
};

// 時間用の選択肢を作る

// multi-select用
// react-select用のオブジェクトを作るfunction
export const createOptions = (list: string[]) => {
  return list.map((item, index) => {
    if (item === "不明") {
      return { value: index, label: "", isDisabled: true };
    }
    return { value: index, label: item };
  });
};

// react-select用のオブジェクトを作るfunction Mapオブジェクト対応
export const createOptionsFromMap = (list: Map<any, string>) => {
  const options: any[] = [];
  list.forEach((value, key) => {
    if (key === 0) {
      options.push({ value: key, label: "", isDisabled: true });
    } else {
      options.push({ value: key, label: value });
    }
  });

  return options;
};



// WEBPACK FOOTER //
// ./src/util/select_option_function.tsx